/* eslint-disable */
<template>
    <div class="ma-0 pa-0">
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <v-row no-gutters class="mb-4">
                        <v-col cols="12" class="d-flex justify-end">
                        <v-btn
                        v-can="{obj_type:'operation', action: 'edit'}"
                        color="action" class="ml-2" :to="{ name: 'edit'}">
                        <v-icon small class="pr-1">add_box</v-icon>nuovo intervento
                        </v-btn>
                        </v-col>
                    </v-row>
                    <div v-if="advanced_search">
                    <v-divider />
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                            <span class="text-h6">Ricerca avanzata</span>
                            <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="4" v-if="!lock_client" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="cliente"
                                v-model="filter.client_id"
                                :items="clients"
                                item-value="_id"
                                item-text="value.name"
                                clearable
                                @change="updateClient"></v-autocomplete>
                        </v-col>
                        <v-col cols="4" v-if="locations.length > 1 || (!lock_client && filter.client_id)" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                    label="sede"
                                    v-model="filter.location_id"
                                    :items="locations"
                                    item-value="_id"
                                    item-text="value.name"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row v-can="{obj_type:'organism', action: 'view'}" no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="ente"
                                v-model="filter.org"
                                :items="orgs"
                                item-value="id"
                                item-text="value.name"
                                clearable></v-autocomplete>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="partner"
                                v-model="filter.partner"
                                :items="partners"
                                item-value="id"
                                item-text="value.name"
                                clearable></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start align-content-center pr-2">
                            <v-combobox dense outlined
                                label="provincia"
                                v-model="filter.district"
                                :items="districts.districts"
                                item-value="id"
                                item-text="name"
                                return-object
                                clearable></v-combobox>
                        </v-col>
                        <v-col cols="6" class="d-flex justify-start align-content-center">
                            <v-combobox dense outlined
                                    label="città"
                                    v-model="filter.city"
                                    :items="districts.cities"
                                    item-value="id"
                                    item-text="name"
                                    return-object
                                    clearable
                                ></v-combobox>
                        </v-col>
                    </v-row>
                    
                    <v-divider v-if="(lock_client && locations.length > 1) || !lock_client" class="my-2" />
                    <v-row no-gutters>
                        <v-col cols="4" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="operatore"
                                v-model="filter.operator"
                                :items="filtered_users"
                                item-value="_id"
                                item-text="name"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="stato intervento"
                                v-model="filter.status"
                                :items="op_status"
                                item-value="value"
                                item-text="label"
                                clearable
                            ></v-autocomplete>
                        </v-col> 
                        <v-col cols="4" class="d-flex justify-start align-content-center">
                            <v-text-field dense outlined
                                label="codice ordine"
                                v-model="filter.order_nr"
                                clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="4" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="famiglia"
                                v-model="filter.search_family"
                                multiple
                                :items="families"
                                clearable></v-autocomplete>
                        </v-col>
                    </v-row>
                    <div class="font-weight-bold">Data intervento</div>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-column">
                            <div class="d-flex justify-left full-width my-2">
                                <v-btn class="" @click="periodChange(0, 0)">oggi</v-btn>
                                <v-btn class="ml-2" @click="periodChange(1, 1)">ieri</v-btn>
                                <v-btn class="ml-2" @click="periodChange(6, 0)">ultimi 7 giorni</v-btn>
                                <v-btn class="ml-2" @click="periodChange(29, 0)">ultimi 30 giorni</v-btn>
                            </div>
                            <div class="d-flex mt-1">
                                <span><CalendarField
                                    v-model="filter.from"
                                    label="da"
                                    clearable>
                                </CalendarField></span>
                                <span class="pl-2"><CalendarField
                                    v-model="filter.to"
                                    label="a"
                                    clearable>
                                </CalendarField></span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-center align-content-center">
                            <v-btn color="primary" class="text-center" @click="search"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2" @click="cancelSearch">annulla</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-4"/>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center mt-4">
                            <span class="d-flex flex-row align-center">
                                <v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    hide-details
                                    @change="changeOrder"
                                ></v-autocomplete>
                                <v-switch class="pl-4" v-if="viewFilterChoices" flat @change="changeSwitchFilter" true-value="org" false-value="owner" v-model="switchView">
                                    <template #prepend>
                                        <v-label class="body-1">proprietà</v-label>
                                    </template>
                                    <template #append>
                                        <v-label class="body-1">tutti</v-label>
                                    </template>
                                </v-switch>
                            </span>
                            <span v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    :items="objects"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    dense
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                            Nessun intervento trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="op in items" :key="op._id">
                            <td>
                                <OperationItem 
                                    v-bind:operation_id="op._id"
                                    @operation_removed="updateSearch"
                                />
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
            <div v-else>
                <v-card-text class="xs12 text-center">
                    <v-progress-circular
                    indeterminate
                    size="64"
                    width="7"
                    color="primary"
                    ></v-progress-circular>
                </v-card-text>
            </div>
        </BasicCard>
    </div>

</template>

<script>
// import _ from 'lodash'
import OperationItem from "./OperationItem"
import {ListManagement} from "../../utils/listMixin"
import BasicCard from "../../components/utils/Basic_card"
import {i_families} from "../../utils/common.js"
import { subDays, startOfDay, endOfDay } from 'date-fns'
import { searchDesign, orderByFields } from "../../utils/dbUtility.js"
import {filterByOrg} from '../../utils/rolesManagement'


export default {
    components:{OperationItem, BasicCard},
    mixins: [ListManagement],
    props: {
        'lock_client': {
            type: Boolean,
            required: false,
            default: false
        },
        'client_id': {
            type: String,
            required: false,
            default: null
        },
        'filter_org': {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data(){
        return {
            families: Object.keys(i_families),
            searching: false,
            disabledForNow: true,    // flag to disable buttons (check methods)
            o_selector: {doc_type:'operation'},
            selector: {},
            fields: ['_id'],
            db: 'operations',
            data:  {},
            filter: {
                client_id: this.client_id ? this.client_id : null,
                location_id: null,
                district: null,
                order_nr: null,
                operator: null,
                search_family: [],
                status: null,
                from: null,
                to: null
            },
            sorting_fields: [
                {label: 'data intervento', value: ['value.op_date', 'value.order_date', 'value.order_nr'], order: ['desc', 'desc', 'desc']},
                {label: 'data ordine', value:['value.order_date', 'value.op_date', 'value.order_nr'], order: ['desc', 'desc', 'desc']},
                {label: 'numero ordine', value:['value.order_nr', 'value.name', 'value.op_date'], order: ['desc', 'desc', 'desc']},
            ],
            sort_fields: {},
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            clients: [],
            locations: [],
            op_status: [
                {label: 'nuovo', value: 'created'},
                {label: 'in corso', value: 'working'},
                {label: 'chiuso', value: 'closed'}
            ],
            districts: {},
            orgs: [],
            partners: [],
            filtered_org: null,
            filtered_user: null,
            list_type: 'operation'
        }
    },
    async beforeMount() {
        this.districts = await this.$store.state.$pouch.get('system', "district:ITALIA")        
        let filter = this.restore_history_params()
        this.setSwitchView()
        if (!filter) {
            this.resetSearch()
        } else if (this.client_id && filter.client_id != this.client_id) {
            this.resetSearch()
        } else {
            this.advanced_search = true
            this.filter = Object.assign({}, this.filter, filter)
            await this.getClients()
        }
        if (this.filter.client_id) {
            await this.getLocations()
            await this.getDepartments()
        } else {
            await this.getClients()
        }
        this.filterUsersSelection()
        
        if (filterByOrg('organism', 'view', this.$store.state.user.roles)) {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "organism", false)
            this.orgs = orderByFields(res, {value: ['value.name'], order: ['asc']})   
            res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', "partner", false)
            this.partners = orderByFields(res, {value: ['value.name'], order: ['asc']})
            console.log(this.orgs, this.partners)
        } else {
            this.filter.org = this.$store.state.user.org_id
        }
        this.changeSwitchFilter()
        //await this.updateSearch()
    },
    methods: {
        resetSearch(){
            this.filter = {
                client_id: this.client_id ? this.client_id : null,
                location_id: null,
                city: null,
                order_nr: null,
                operator: null,
                search_family: [],
                status: null,
                from: null,
                to: null,
                org: null,
                partner: null
            }
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page: 1, sort_fields: this.sorting_fields[0]})
        },
         async getClients(){
                let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', 'client', false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                // console.log('res -', res)
                this.clients = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.clients = []
            } 
            // console.log('CLIENTS', this.clients)
        },
        async getDepartments() {
            if (this.filter.location_id) {
                let location = await this.$store.state.$pouch.get("registry", this.filter.location_id)
                this.departments = Object.values(location.departments)
            } else {
                this.filter.department_id = null
                this.departments = []
            }
        },
        async getLocations() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.filter.client_id], false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                // console.log('res -', res)
                this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.locations = []
            }
        },
        async updateClient() {
          if (this.filter.client_id) {
              await this.getLocations()
            } else {
                this.filter.location_id = null
                this.filter.department_id = null
                this.locations = []
                this.departments = []
            }
        },
        async updateSearch() {
            this.searching = true
            if (this.filtered_user) {
                this.filter.operator = this.filtered_user
            } else if (!this.advanced_search) {
                this.filter.operator = null
            }
            
            var selectors = ['operation']
            if (this.filter.client_id) {
                selectors.push(['client', this.filter.client_id])
            }
            if (this.filter.location_id) {
                selectors.push(['location', this.filter.location_id])
            }
            if (this.filter.order_nr) {
                selectors.push(['order_nr', this.filter.order_nr])
            }
            if (this.filter.status) {
                selectors.push(['status', this.filter.status])
            }
            if (this.filter.operator) {
                selectors.push(['operator', this.filter.operator])
            }
            if (this.filter.org){
                selectors.push(['org', this.filter.org])
            }
            if (this.filter.partner) {
                selectors.push(['partner', this.filter.partner])
            }
            let res = await this.searchFromDesignNew('operations/searchByData', 'all_keys', selectors, false)
            //console.log('SEARCH WITHOUT FILTER', res)
            //console.log('research result OBJECTS', this.objects)
            
            if (this.filter.district && !this.filter.location){
                let district = ''
                if ( typeof(this.filter.district) === "string") {
                    district= this.filter.district.toLowerCase()
                    let tmp = _.find(this.districts.districts, function(o) { 
                        return o.name.toLowerCase() == district 
                    });
                    if (tmp) {
                        district = tmp.id.toLowerCase()
                    }
                } else {
                    district= this.filter.district.id.toLowerCase()
                }
                let loc_dist = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['district', district], false)
                let d_search = [...Array(loc_dist.length)].map((_, i) => ['location', loc_dist[i].id])
                // console.log("LOC DIST" ,loc_dist)
                let d_ops = await this.searchFromDesignNew('operations/searchByData', 'keys', d_search, false)

                res = _.intersectionWith(res, d_ops, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }

            //************************************************************************* */
            if (this.filter.city){
                console.log(this.filter.city)
                let city = ''
                if ( typeof(this.filter.city) === "string") {
                    city = this.filter.city.toLowerCase()
                    let tmp = _.find(this.districts.cities, function(o) { 
                        return o.name.toLowerCase() == city 
                    });
                    if (tmp) {
                        city = tmp.name.toLowerCase()
                    }
                } else {
                    city= this.filter.city.name.toLowerCase()
                }
                let loc_city = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['city', city], false)
                let l_search = [...Array(loc_city.length)].map((_, i) => ['location', loc_city[i].id])
                let l_ops = await this.searchFromDesignNew('operations/searchByData', 'keys', l_search, false)
                res = _.intersectionWith(res, l_ops, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }
            



            if (this.filter.from || this.filter.to) {
                let from = 0
                let d_to = new Date()
                d_to.setFullYear(d_to.getFullYear() + 50)
                let to = d_to.getTime()
                
                if (this.filter.from) {
                    from = this.filter.from
                }
                if (this.filter.to) {
                    to = this.filter.to
                }
                let sd_from = startOfDay(from).getTime()
                let ed_to = endOfDay(to).getTime()
                let res_date = await this.searchFromDesignNew('operations/searchByData', 'range', [['op_date', sd_from], ['op_date', ed_to]], false)
                res = _.intersectionWith(res, res_date, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }
            
            if (this.filter.search_family.length > 0) {
                let f_keys = [...Array(this.filter.search_family.length)].map((_, i) => ['family', this.filter.search_family[i]])
            
                let f_instrs = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'keys', f_keys, false)
                let i_ids = _.map(f_instrs, 'id');
                let i_ops = await this.searchFromDesignNew('operations/searchByData', 'keys', i_ids, false)
                let items = _.intersectionWith(res, i_ops, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
                this.objects = this.orderBy(items, this.sort_fields)
                console.log("$$ SORT ITEMS", this.sort_fields, items)
            } else {
                this.objects = this.orderBy(res, this.sort_fields)
                console.log("$$ SORT RES", this.sort_fields, res)
            }
            this.searching = false
        },
        periodChange(f_days, t_days) {
            let now = (new Date()).getTime()
            this.filter.from = subDays(now, f_days).getTime()
            this.filter.to = subDays(now, t_days).getTime()
        },
        initSelector() {
        },
        customSelection(){
            // to be implemented with search

        },
    }
}
</script>
